import React, { useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { version } from '../globals.json';
import Form from 'react-bootstrap/Form';
import { Row } from "react-bootstrap";
const VIEW_MODE = {
  BASIC: "Advanced", //These are switched because it is used in the display mode
  ADVANCED: "Basic"
};


export default function Header(props) {
  const [showModal, setShowModal] = React.useState(false);
  const [gitVersion, setGitVersion] = React.useState("(Loading Module)");

  const view_name = props.view;
  const set_view_name = props.set_view;

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);


  function changeView() {
    set_view_name(view_name == VIEW_MODE.BASIC ? VIEW_MODE.ADVANCED : VIEW_MODE.BASIC);
  };


  useEffect(() => {
    console.log("Getting git version...");

    if (window.createBankForNET != undefined) {
      window.createBankForNET().then((Module) => {
        const git_version = Module.Input.GetGitCommitHash();
        console.log(git_version);
        setGitVersion(git_version);
      });
    }

  }, [window.createBankForNET]);

  return (
    <Navbar bg="dark" variant="dark" className="justify-content-between">
      <Navbar.Brand>
        BankforNET
        <span style={{ fontSize: "smaller" }}> by </span>
        <img
          alt="ecorisQ Logo"
          src="/logoEcorisQ.png"
          height="25"
          className="d-inline-block align-top"
        />
      </Navbar.Brand>
      <Row>
        <Form.Label
          style={{ color: "white", marginRight: "10px", marginBottom: "0rem" }}
        >Switch to {view_name} View</Form.Label>
        <Form.Check
          type="switch"
          id="switch_basicpro"
          onChange={changeView}
        />
        <Button
          variant="dark"
          className="d-inline-flex align-items-center"
          style={{ padding: "0", marginLeft: "1rem", marginRight: "1rem" }}
          onClick={handleShow}
        >
          <FontAwesomeIcon icon={faInfoCircle} />
        </Button>
      </Row>
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>About BankForNET</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div>
            <p>Version Information:</p>
            <ul>
              <li>BankforNET Web {version}</li>
              <li>BankforNET {gitVersion}</li>
            </ul>
          </div>

          <p>
            Copyright (c) 2020-2025 CoSci LLC, USA
            <br />
            &lt;software@cosci-llc.com&gt;
          </p>

          <p>
            End user license agreement located <a href="/eula.html">here</a>
          </p>

          <p>
            Full copyright and attributions located <a href="/copyright.html">here</a>
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={handleClose} variant="primary">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Navbar>
  );
}
